import { createSelector } from 'reselect';
import { RootState } from 'store/types';
import { getData } from 'lib/amwell/normalizer';

export const speedPassStateSelector = (state: RootState) => state.amwell.activeConsumer.speedPass;

export const speedPassSelector = createSelector(speedPassStateSelector, v => v.data);
export const speedPassErrorSelector = createSelector(speedPassStateSelector, v => v.error);
export const speedPassLoadingSelector = createSelector(speedPassStateSelector, v => v.isFetching);

export const speedPassDataSelector = (rootState: RootState) => {
  const { data } = rootState.amwell.activeConsumer.speedPass;
  return !Array.isArray(data) ? getData(data) : null;
};
